<template>
  <banner-detail :is-edit='false' :groupId="this.$route.params.groupId">
  </banner-detail>
</template>

<script>
import BannerDetail from '@/components/Shop/Theme/BannerDetail'
export default {
  name: 'CreateBanner',
  components: {
    BannerDetail
  },
  created() {
    console.log(this.$route.params.groupId)
  }
}
</script>

